export default "__VITE_ASSET__a509cbe8__"